import { Market } from '../../types/shared/Market';
import { VendorList } from '../../types/shared/Vendor';
import {
  PlacementByVendor,
  NewVendorPlacement,
} from '../../types/shared/Placement';

export default function getNewVendorPlacement(
  market: Market | null | undefined,
  position: number | null | undefined,
  options: {
    vendors: VendorList | null | undefined;
    placement: PlacementByVendor | null | undefined;
  },
) {
  let placementByDate: NewVendorPlacement = {};
  let { vendors, placement } = options;
  if (!market || !vendors || !placement || !position) {
    return placementByDate;
  }

  // TODO: Update the data structure to use NewVendorPlacementByIndex instead
  for (let date of market.dates) {
    for (let vendorID of Object.keys(placement)) {
      let vendor = vendors.getByID(vendorID);
      if (!vendor || (vendor.markets?.[market.id] || '').indexOf(date) === -1) {
        continue;
      }
      let vendorMarkets = placement[vendorID] || {};
      let vendorDates = vendorMarkets[market.id] || {};
      let placementIndexes = vendorDates[date] || [];
      for (let index of placementIndexes) {
        if (index + 1 === position) {
          placementByDate[date] = vendor;
        }
      }
    }
  }
  return placementByDate;
}
